export default __webpack_public_path__ + "static/unilever-side-a9fd9902fa039aad2074afab7ce4b1ff.png";